// The recruiter portal's visual contract: surfaces, ink, accent, status tones and density.
//
// Dense enterprise: recruiters work these screens all day across hundreds of rows, so the portal
// favours data per screen over air — 13px data text, 44px rows, 30px controls, 6px corners, flat
// bordered surfaces with no drop shadows. Sizes are explicit because the recruiter MUI theme sets
// `body2` to 0.675rem, smaller than `caption`, so variant-driven text comes out smaller than the
// label above it.
export const RECRUITER_TOKENS = {
	radius: 6,
	radiusSm: 4,
	border: '#DDE3E7',
	borderStrong: '#C9D2D7',
	surface: '#FFFFFF',
	surfaceSubtle: '#F4F6F8',
	rowHover: '#F2F6F7',
	ink: '#10242C',
	inkMuted: '#51656D',
	inkFaint: '#7F9197',
	accent: '#03606A',
	accentHover: '#024D55',
	accentSoft: '#E3F4F2',
	shadow: 'none',
	shadowRaised: '0 6px 20px rgba(16, 44, 54, 0.16)',
	font: { xs: 10, sm: 11, md: 12, lg: 13, xl: 14, xxl: 16, display: 20 },
	tones: {
		neutral: { fg: '#51656D', bg: '#EEF1F3', border: '#DDE3E7' },
		accent: { fg: '#03606A', bg: '#E3F4F2', border: '#B4DCD8' },
		success: { fg: '#0E7A50', bg: '#E6F4EC', border: '#BADFCB' },
		warning: { fg: '#8F5600', bg: '#FFF3DF', border: '#F0D5A6' },
		danger: { fg: '#B3261E', bg: '#FCEAE8', border: '#F0C2BD' },
	},
}
